import React from "react";

// Category/Sections Header in context of Menu

const Header = () => {
	return (
		<div className="header-container">
			<div className="header-text">
				<div className="title">Sections</div>
				<div className="subtitle">Central repository for all your sections</div>
			</div>
		</div>
	);
};

export default Header;
